export default theme => ({
  root: {
    width: '100%',
    height: '100%',
    '& [class*="GridMotion__root"]': {
      overflowX: 'auto',
      '& .grid-stack': {
        minWidth: '1200px'
      }
    }
  }
});